import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router';
import { ModifierApi, productApi } from '../../../App/api/ProductListing.apis';
import LoaderContext from '../../../Components/loader';
import { formattedAmount } from '../../../utils/helpers/Functions.helper';
import { FaStar } from 'react-icons/fa';
import { VscDebugRestart } from "react-icons/vsc";
import { MdOutlineCancel } from 'react-icons/md';
import ModifierComp from '../../../Components/ProductModal/ModifierComp';
import { IoIosArrowBack } from 'react-icons/io';
import PriceTooltip from '../../../Components/products/ToolTip';

const FoodPage = () => {
    const { productId } = useParams();
    const [isModifier, setIsModifier] = useState([]);
    const { handleLoading } = useContext(LoaderContext);
    const [foodData,setFoodData]=useState(null);
    console.log("foodData:",foodData);
    
    const fetchSingleProduct = async () => {
        handleLoading(true);
        if (productId) {
          try {
            const res = await productApi.getFoodProductById(productId);
            const modifier = await ModifierApi.getModifierById(productId);
                //   console.log("Modifier:", modifier.data.data);
                  setIsModifier(modifier.data.data)
            setFoodData(res.data.data);
          } catch (err) {
            console.log(err);
          } finally {
            handleLoading(false);
          }
        }
      };
      const renderStars = (rating) => {
        const stars = [];
        for (let i = 1; i <= 5; i++) {
            if (i <= rating) {
                stars.push(<span key={i} ><FaStar className='text-yellow-400'/></span>);
            } else {
                stars.push(<span key={i} ><FaStar className='text-gray-300 '/></span>);
            }
        }
        return stars;
    };
      useEffect(() => {
          fetchSingleProduct();
        //   fetchSingleProductReview();
        }, [productId]);
  return (
    <div className='text-lg' style={{ padding: '20px', }}>
           <div className="flex">
          <div className='mr-1'><IoIosArrowBack /></div>  
           <div className="relative w-[40rem]">
                   <img
                     src={foodData?.primary_image}
                     alt={foodData?.name}
                     className="object-cover h-full w-full rounded-md"
                   />
                   {/* Category Tag */}
                   <span className="absolute top-2 left-2 bg-green-500 text-white text-xs px-2 py-1 rounded-full">
                     {foodData?.status}
                   </span>
                   
            </div>

           <div className='ml-4 text-xl'>
           <h1 className='font-bold text-2xl'>{foodData?.name}</h1>
           <div className='flex text-sm'>{renderStars(foodData?.rating)}</div>
            <p className='text-sm'>{foodData?.sub_category?.name}</p>
            <div className="flex">
            <p className='font-semibold'> {formattedAmount(foodData?.taxData?.grandTotal?.$numberDecimal)}</p>
            {/* <PriceTooltip
          mrp={1.5*foodData?.taxData?.grandTotal?.$numberDecimal}
          discount={1.5*foodData?.taxData?.grandTotal?.$numberDecimal-foodData?.taxData?.grandTotal?.$numberDecimal}
          specialPrice={foodData?.taxData?.grandTotal?.$numberDecimal}
        /> */}
            </div>
            <div className='flex flex-wrap mt-2 text-lg'>
            {isModifier?
                        <ModifierComp data={isModifier}/>
                        :
                        "customization Not Available"
                        }
            </div>
            {/* <p>{foodData?.status}</p> */}
            {/* <p><strong>Average Rating:</strong> {foodData?.average_rating}</p> */}
           </div>
           </div>

            <div className='p-4 border-b' dangerouslySetInnerHTML={{ __html: foodData?.description }} style={{ margin: '10px 0'}}></div>
            
            <div className='border px-4 py-2 rounded-md mb-2'>
            <h3 className='flex items-center font-semibold'><MdOutlineCancel  className='mr-1 text-red-500'/>Cancellation Policy:</h3>
            <div dangerouslySetInnerHTML={{ __html: foodData?.cancellation_policy }}></div>
            </div>
            <div className='border px-4 py-2 rounded-md'>
            <h3 className='flex items-center font-semibold'><VscDebugRestart className='mr-1 text-yellow-500'/>Return Policy:</h3>
            <div dangerouslySetInnerHTML={{ __html: foodData?.return_policy }}></div>
            </div>
        </div>
  )
}

export default FoodPage